import { LoanName } from '@appTypes/LoansApi.interface'

export function getDisplayLoanName(loanName: string): string {
    return loanName
}
